export default __webpack_public_path__ + "static/media/AFDB_logo.ef95e0cb.png";